export default "__VITE_ASSET__BTKMg$FQ__"